// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f605263b","453":"82a1630a","455":"12d49512"}[chunkId] + ".chunk.js";
};